import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  email: payload.email,
  phone: payload.phone,
  ext: payload.ext,
  cellphone: payload.cellphone,
  position: payload.position,
  customer_id: payload.customer_id
})
var crud = new Crud('SupplierContacts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  contacts: []
}

const mutations = {
  ...crud.mutations,
  SET_CONTACTS (state, payload) {
    state.contacts = payload
  },
  ADD_CONTACT (state, payload) {
    state.contacts.unshift(payload)
  },
  DELETE_CONTACT (state, payload) {
    const idx = state.contacts.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.contacts, idx)
    }
  },
  UPDATE_CONTACT (state, payload) {
    const idx = state.contacts.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.contacts, idx, payload)
    }
  }
}

const actions = {
  ...crud.actions,
  async loadContacts ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`suppliers/${payload.id}/contacts?&page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CONTACTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addRecord ({ commit }, payload) {
    const record = model(payload)

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post(`suppliers/${payload.supplierId}/contacts`, record)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CONTACT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.contact', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`suppliers/${payload.supplierId}/contacts/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CONTACT', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.supplier_contacts', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editRecord ({ commit }, payload) {
    const record = model(payload)

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.put(`suppliers/${payload.supplierId}/contacts/${payload.id}`, record)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CONTACT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.contacts', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  ...crud.getters,
  contacts: state => state.contacts
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
